export { Section } from './section.component';
export type { SectionProps } from './section.component';
